export default "__VITE_ASSET__D6nUX_xl__"